var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "notifs",
      class: {
        spinner: !_vm.loaded,
        empty: _vm.notifications.length == 0 && _vm.loaded
      }
    },
    [
      _vm.loaded
        ? _c("div", [
            _c(
              "div",
              { staticClass: "notifs-header" },
              [
                _c("h3", [_vm._v("Notifications")]),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { to: { name: "notifications_page" } } },
                  [
                    _vm._v("\n        View all\n        "),
                    _vm.numExtra > 0
                      ? _c("span", [
                          _vm._v(
                            " (" +
                              _vm._s(_vm.numExtra.toLocaleString()) +
                              " not shown) "
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.notifications.length > 0
              ? _c(
                  "ul",
                  { staticClass: "notifs-list" },
                  _vm._l(_vm.notifications, function(notification) {
                    return _c(
                      "li",
                      {
                        key: notification.notification_id,
                        staticClass: "notif-item",
                        class: {
                          unread: !notification.read,
                          dismissed: notification.dismissed
                        }
                      },
                      [
                        _c("span", {
                          attrs: {
                            id: "notification-" + notification.notification_id
                          },
                          domProps: { innerHTML: _vm._s(notification.message) }
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "time" }, [
                          _vm._v(_vm._s(notification.notification_ts))
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "dismiss b-sprite-global close",
                            attrs: { "aria-label": "Close" },
                            on: {
                              click: function($event) {
                                return _vm.dismissNotification(
                                  notification.notification_id
                                )
                              }
                            }
                          },
                          [_vm._v("\n          ×")]
                        )
                      ]
                    )
                  }),
                  0
                )
              : _c("ul", { staticClass: "notifs-list empty" }, [
                  _c("li", { staticClass: "empty row" }, [
                    _vm._v("No unread notifications")
                  ])
                ]),
            _vm._v(" "),
            _vm.notifications.length > 0
              ? _c(
                  "button",
                  {
                    staticClass: "notifs-dismiss btn-link",
                    on: { click: _vm.dismissAllNotifications }
                  },
                  [_vm._v("\n      Dismiss all\n    ")]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showReferralHistoryModal
        ? _c("ReferralHistoryModal", {
            attrs: { "legacy-loaded": true },
            on: {
              close: function($event) {
                _vm.showReferralHistoryModal = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }